/**
 * Simple log
 */
export const log = console.log;

/**
 * Log that will be save in a file
 */
export const saveLog = console.log;
